export const map = (obj) => Object.keys(obj).filter((k) => obj[k]);
